import React, { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const FloatingBubbles: React.FC = () => {
  const [bubbles, setBubbles] = useState<Array<{
    id: number;
    size: number;
    duration: number;
    delay: number;
    x: number;
    rotation: number;
    wobble: number;
    color: string;
  }>>([]);

  const colors = [
    'from-primary/5 to-secondary/5',
    'from-secondary/5 to-primary/5',
    'from-primary/3 to-white/3',
  ];

  const createBubbles = useCallback(() => {
    const newBubbles = Array.from({ length: 4 }, (_, i) => ({
      id: i,
      size: Math.random() * (120 - 40) + 40,
      duration: Math.random() * (25 - 15) + 15,
      delay: Math.random() * -20,
      x: Math.random() * window.innerWidth,
      rotation: Math.random() * 360,
      wobble: Math.random() * 20 + 10,
      color: colors[Math.floor(Math.random() * colors.length)],
    }));
    setBubbles(newBubbles);
  }, []);

  useEffect(() => {
    createBubbles();
    const interval = setInterval(createBubbles, 30000);
    
    const handleResize = () => {
      createBubbles();
    };
    
    window.addEventListener('resize', handleResize);
    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', handleResize);
    };
  }, [createBubbles]);

  const handleBubbleClick = (id: number) => {
    setBubbles(prev => prev.map(bubble => 
      bubble.id === id 
        ? { 
            ...bubble, 
            size: bubble.size * 1.1, 
            rotation: bubble.rotation + 360,
            color: colors[Math.floor(Math.random() * colors.length)]
          }
        : bubble
    ));
  };

  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      <AnimatePresence>
        {bubbles.map((bubble) => (
          <motion.div
            key={bubble.id}
            initial={{ y: '120vh', rotate: 0, scale: 1 }}
            animate={{ 
              y: '-20vh',
              x: ['-50px', '50px', '-50px'],
              rotate: [0, 180, 360],
              scale: [1, 1.05, 1]
            }}
            exit={{ y: '-20vh', opacity: 0 }}
            transition={{ 
              duration: bubble.duration,
              delay: bubble.delay,
              repeat: Infinity,
              ease: 'linear'
            }}
            onClick={() => handleBubbleClick(bubble.id)}
            className={`absolute cursor-pointer transition-opacity`}
            style={{
              width: `${bubble.size}px`,
              height: `${bubble.size}px`,
              left: `${bubble.x}px`,
              pointerEvents: 'auto',
              opacity: 0.2,
            }}
          >
            <motion.div 
              className={`w-full h-full overflow-hidden rounded-full bg-gradient-to-b ${bubble.color} backdrop-blur-[1px]`}
              animate={{ rotate: [0, 2, -2, 0] }}
              transition={{ 
                duration: bubble.wobble,
                repeat: Infinity,
                ease: 'easeInOut'
              }}
            >
              <img
                src="https://i.ibb.co/3m89KdT7/testtt.png"
                alt="Floating Logo"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
              />
            </motion.div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default FloatingBubbles;

export { FloatingBubbles };